module.exports = __webpack_public_path__ + "static/media/  (104).d4f57fdd.jpg";